import { render, staticRenderFns } from "./NsAccordion.vue?vue&type=template&id=afb7ff4e&scoped=true&"
import script from "./NsAccordion.vue?vue&type=script&lang=js&"
export * from "./NsAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb7ff4e",
  null
  
)

export default component.exports